import { ApprovedCountriesAction } from '../actions/approvedCountries';
import { ReduxStore } from '../interfaces/store';

export const approvedCountriesReducer = (
  state: ReduxStore['approvedCountries'] = { codes: [], status: 'idle' },
  action: ApprovedCountriesAction
): ReduxStore['approvedCountries'] => {
  switch (action.type) {
    case 'GET_APPROVED_COUNTRIES_REQUEST':
      return { ...state, status: 'pending' };

    case 'GET_APPROVED_COUNTRIES_SUCCESS':
      return { codes: action.payload, status: 'success' };

    case 'GET_APPROVED_COUNTRIES_FAILURE':
      return { ...state, status: 'error' };

    default:
      return state;
  }
};
